import { Menu } from 'lucide-react'
import { SearchMenu } from './SearchMenu'
import { UserMenu } from './UserMenu'
import { NotificationBell } from '@/features/notifications'
import type { MembershipSummary } from '@/lib/types'

/**
 * The top bar: a mobile sidebar toggle, workspace search, and the account menu.
 *
 * It is sticky rather than fixed so long boards scroll under it without the
 * page needing a compensating top padding.
 */
export function Topbar({
  membership,
  onOpenSidebar,
}: {
  membership: MembershipSummary
  onOpenSidebar: () => void
}) {
  return (
    <header className="sticky top-0 z-20 flex h-14 items-center gap-3 border-b border-ink-200 bg-white/85 px-4 backdrop-blur dark:border-ink-800 dark:bg-ink-950/85">
      <button
        type="button"
        onClick={onOpenSidebar}
        aria-label="Open navigation"
        className="-ml-1 rounded-md p-2 text-ink-600 transition hover:bg-ink-100 md:hidden dark:text-ink-300 dark:hover:bg-ink-800"
      >
        <Menu className="size-5" aria-hidden="true" />
      </button>

      <div className="min-w-0 flex-1">
        <SearchMenu membership={membership} />
      </div>

      <NotificationBell />
      <UserMenu />
    </header>
  )
}
